import {
  faBuildingUser,
  faBarsProgress,
  faDashboard,
  faDiceD20,
  faCartShopping,
  faArrowDownWideShort,
  faAnglesRight,
  faDiamondTurnRight,
  faScrewdriverWrench,
  faRightToBracket,
  faCubesStacked,
  faGroupArrowsRotate,
  faBrazilianRealSign,
  faFileSignature,
  faFileInvoiceDollar,
  faGem,
  faFileEdit,
  faAddressBook,
  faMoneyCheckDollar,
  faRankingStar,
  faDiamond,
  faUserCheck,
  faBoxesPacking,
  faRouble,
  faCheckToSlot,
  faBarcode,
  faDollar,
  faRssSquare,
  faLocust,
  faCartFlatbed,
  faFilePen,
  faPenToSquare,
  faFileLines,
  faCircle,
  faSquare,
  faHeart,
  faGears
} from "@fortawesome/free-solid-svg-icons"
import CryptoJS from 'crypto-js';

export const GetLoginCredentialDb = (user, yearId) => {
  return { YearId: yearId, ClientCode: user.clientCode, LoginName: user.username, UserKey: user.userKey }
}

export const ENUM_USERSETING_PARAMS = {
  StartUp: "STARTUP",
}

export const ENUM_BILL_PAYMENT_TYPE = {
  FULL: "FULL",
  PART: "PART",
}
const outTypeEnum = {
  R: "R",
  G: "G",
  C: "C"
}
export const ENUM_PAGEACTION_TYPE = {
  Delete: "Delete",
  Edit: "Edit"
}

export const ENUM_ENCRYPT_CODE = {
  receivable: "BuyQbvMAu@jYpIIf",
  payable: "hbtv1378hXt@c0nd",
  difference: "iplt@wDCp|HUjW!2@c0nd",
  purchase: "sfertq287857rtd",
  sale: "jhueki248e6tt",
  challan: "hm!urtrt[rhXt"
}
export const ENUM_INTCAL_OPTION = {
  WithGst: "WithGST",
  WithOutGst: "WithOutGST"
}
export const ENUM_CERTIFIED_FROM = {
  GIA: "GIA",
  GIADIRECT: "GIA DIRECT",
  IGI: "IGI",
  HRD: "HRD",
  CUSTOM: "CUSTOM"
}

export const ENUM_CERTIFIEDLAB = [
  { key: ENUM_CERTIFIED_FROM.GIA, value: ENUM_CERTIFIED_FROM.GIA },
  { key: ENUM_CERTIFIED_FROM.GIADIRECT, value: ENUM_CERTIFIED_FROM.GIADIRECT },
  { key: ENUM_CERTIFIED_FROM.IGI, value: ENUM_CERTIFIED_FROM.IGI },
  { key: ENUM_CERTIFIED_FROM.HRD, value: ENUM_CERTIFIED_FROM.HRD },
  { key: ENUM_CERTIFIED_FROM.CUSTOM, value: ENUM_CERTIFIED_FROM.CUSTOM }
]
export const ENUM_BILL_TYPE_LIST = [
  { value: "--Select-", key: "" },
  { value: "FULL", key: "FULL" },
  { value: "PART PAYMENT", key: "PART" }
]
export const ENUM_MOD_NAME = {
  //Memo setting
  SalePolishMemoSingle: "Sale_Polish_Memo_Single",
  SaleRoughMemoSingle: "Sale_Rough_Memo_Single",
  SaleRejectionMemoSingle: "Sale_Rejection_Memo_Single",
  PurchasePolishMemoSingle: "Purchase_Polish_Memo_Single",
  PurchaseRoughMemoSingle: "Purchase_Rough_Memo_Single",
  PurchaseRejectionMemoSingle: "Purchase_Rejection_Memo_Single",
  SalePolishMemoMix: "Sale_Polish_Memo_Mix",
  SaleRoughMemoMix: "Sale_Rough_Memo_Mix",
  SaleRejectionMemoMix: "Sale_Rejection_Memo_Mix",
  PurchasePolishMemoMix: "Purchase_Polish_Memo_Mix",
  PurchaseRoughMemoMix: "Purchase_Rough_Memo_Mix",
  PurchaseRejectionMemoMix: "Purchase_Rejection_Memo_Mix",
  //invoice setting
  SalePolishInvoiceSingle: "Sale_Polish_Invoice_Single",
  SaleRoughInvoiceSingle: "Sale_Rough_Invoice_Single",
  SaleRejectionInvoiceSingle: "Sale_Rejection_Invoice_Single",
  PurchasePolishInvoiceSingle: "Purchase_Polish_Invoice_Single",
  PurchaseRoughInvoiceSingle: "Purchase_Rough_Invoice_Single",
  PurchaseRejectionInvoiceSingle: "Purchase_Rejection_Invoice_Single",
  SalePolishInvoiceMix: "Sale_Polish_Invoice_Mix",
  SaleRoughInvoiceMix: "Sale_Rough_Invoice_Mix",
  SaleRejectionInvoiceMix: "Sale_Rejection_Invoice_Mix",
  PurchasePolishInvoiceMix: "Purchase_Polish_Invoice_Mix",
  PurchaseRoughInvoiceMix: "Purchase_Rough_Invoice_Mix",
  PurchaseRejectionInvoiceMix: "Purchase_Rejection_Invoice_Mix",
  GeneralSettings: "General_Settings",
  StockPolishSingle: "Stock_Polish_Single",
  StockRoughSingle: "Stock_Rough_Single",
  StockRejetionSingle: "Stock_Rejection_Single",
  StockPolishMix: "Stock_Polish_Mix",
  StockRoughMix: "Stock_Rough_Mix",
  StockRejectionMix: "Stock_Rejection_Mix",
  MixSlitPolishMix: "MixSlit_Polish_Mix",
  MixSlitPolishSingle: "MixSlit_Polish_Single",
  MixSlitRoughSingle: "MixSlit_Rough_Single",
  MixSlitRoughMix: "MixSlit_Rough_Mix",
  GeneralPurchase: "General_Purchase",
  DemandGeneration: "Demand_Generation",
  PolishPriceList: "Polish_Price_List"


}
export const ENUM_MOD_PARAMETER = {
  MemoEntry: {
    Items: "Items",
    Shape: "Shape",
    Color: "Color",
    Purity: "Purity",
    Size: "Size",
    LxWRatio: "LxWRatio",
    ReportNo: "ReportNo",
    LotNo: "LotNo",
    PktNo: "PktNo",
    Lab: "Lab",
    CertiNo: "CertiNo",
    ItemDetail: 'Item_Detail',
    Remarks: "Remarks",
    RapRate: "RapRate",
    DiscPer: "DiscPer",
    AllowNegativeStock: "Allow_Negative_Stock"

  },
  GeneralSetting: {
    MixStockByLCode: "Mix_Stock_By_L_Code",
    MixStockByPurity: "Mix_Stock_By_Purity",
    MixStockByColor: "Mix_Stock_By_Color",
    MixStockByItem: "Mix_Stock_By_Item",
    MixStockByShape: "Mix_Stock_By_Shape",
    MixStockByLwRatio: "Mix_Stock_By_LwRatio",
    MixStockBySize: "Mix_Stock_By_Size",
    CurrencyType: "Currency_Type",
    CurrencyFormatBy: "Currency_Format_By",
    ClientSettingType: "Client_Setting_Type",
    RoughStockByLCode: "Rough_Stock_By_Lcode",
    RoughStockByItem: "Rough_Stock_By_Item",
    RoughStockBySize: "Rough_Stock_By_Size",
    Barcode: "Barcode",
    BarcodeSplitter: "Barcode_Splitter",
    UseMfgNoAsMktNo: "Use_Mfg_No_As_Mkt_No",
    IsMktIDSingleColumn: "Is_Mkt_ID_Single_Column",
    IsMfgIDSingleColumn: "Is_Mfg_ID_Single_Column",
    DefaultStockDiv: "Default_Stock_Div",
    SecuritySetting: "SecuritySetting",
    OpenNavigationInNewTab: "OpenNavigationInNewTab"

  },
  GeneralPurchase: {
    Meter: "Meter",
    Weight: "Weight",
    LotNo: "Batch_Lot",
    ItemDetail: "Item_Detail",
    Broker: "Broker",
    Location: "UnitCode",
    RoundNetAmt: "RoundNetAmt",
    ZeroPcs: "ZeroPcs"


  },
  DemandGeneration: {
    Shape: "Shape",
    Color: "Color",
    Purity: "Purity",
    Size: "Size",
    Length: "Length",
    Diameter: "Diameter",
    Cut: "Cut",
    Polish: "Polish",
    Lab: "Lab",
    Flrcn: "Flrcn",
    Symtry: "Symtry"

  },
}

export const ENUM_CURRENCY_SETTING_VAL = {
  RS: "RS",
  Dollar: "$",
  DUAL: "DUAL",
}

export const ENUM_CLIENT_SETTING_VAL = {
  SINGLE: "SNG",
  MIX: "MIX",
  DUAL: "DUAL",
}
export const ENUM_MIXSLIT_ENTRYTYPE = {
  MixToMix: 1,
  MixToSingle: 2,
  SingleToSingle: 3, SingleToMix: 4,
}
export const ENUM_TRADEOF_TYPE = {
  Rough: "Rough",
  Polish: "Polish",
  Rejection: "Rejection"

}
export const ENUM_TRADEOF_LIST = [
  { value: "Rough", key: "R" },
  { value: "Polish", key: "P" },
  { value: "Rejection", key: "J" }

]
export const ENUM_POLISH_PRICE_TYPE = [
  { value: "A", key: "A" },
  { value: "B", key: "B" },
  { value: "C", key: "C" }

]
export const ENUM_GRADDING_TYPE = [
  { value: "Ploting", key: "PLOT" },
  { value: "Without Ploting", key: "WOTPLOT" },

]
export const ENUM_BILL_TYPE = {
  Sale: "Sale",
  Purchase: "Purchase",

}
export const ENUM_ADVSEARCH_PARAM = {
  VouNo: "VouNo",
  Shape: "Shape",
  Color: "Color",
  Purity: "Purity",
  Size: "Size",
  LwRatio: "LwRatio",
  Party: "Party",
  Broker: "Broker",
  Item: "Item",
  VouFromDate: "VouFromDate",
  VouToDate: "VouToDate",
  DueFromDate: "DueFromDate",
  DueToDate: "DueToDate",
  Status: "Status",
  LotNo: "LotNo",
  PktNo: "PktNo",
  IsMfgNo: "IsMfgNo"


}
export const PAGE_API_FILTER = {
  CompCode: 0, BillType: '', TradeOF: ""
}
export const ENUM_STATUS = {
  Final: "Final",
  Pending: "Pending",
  Return: "Return",
  PartialReturn: "PartialReturn",
  PartialFinal: "PartialFinal",
  Paid: "Paid",
  PartPaid: "PartPaid"
}
export const ENUM_ENTRY_TYPE = {
  SinglePacket: "Single",
  Mix: "Mix",

}
export const ENUM_TRANSACTION_TYPE = {
  RECEIVE: "Receive",
  PAYMENT: "Payment"

}
export const ENUM_TRADEOF_CODE = {
  Rough: "R",
  Polish: "P",
  Rejection: "J"

}

export const encryptText = (text) => {
  const secretKey = ''; // Use a secret key for encryption
  const ciphertext = CryptoJS.AES.encrypt(text, secretKey).toString();
  return ciphertext;
};

// Decrypt the text
export const decryptText = (ciphertext) => {
  const secretKey = 'mySecretKey'; // Use the same key for decryption
  const bytes = CryptoJS.AES.decrypt(CryptoJS.enc.Hex.parse(ciphertext), secretKey);
  const originalText = bytes.toString(CryptoJS.enc.Utf8);
  return originalText;
};

export const ENUM_ADM_KEY = "AdmWebApp"

export const funValidateNoInput = (value) => {

  if (/^\d*\.?\d*$/.test(value))
    return true
  else
    return false

}

export const isValidNumber = (value) => {
  return /^-?\d*\.?\d*$/.test(value);
};
export const getModVisiblity = (Parameter, data) => {

  if (data && data.length > 0) {
    const filData = data.filter((ele) => ele.Parameter == Parameter)

    if (filData && filData?.length > 0)
      return filData[0].Visible.toLowerCase() == 'true' ? true : false;
    else return false

  }
  else
    return false
}
export const funGetFormatCurrency = (value, CurrencyFormat) => {
  if (CurrencyFormat && CurrencyFormat != "" && CurrencyFormat != null)
    return (parseFloat(value) / parseFloat(CurrencyFormat ?? 0)).toFixed(3);
  else
    return value
}

export const getModMandatory = (Parameter, data) => {

  if (data && data.length > 0) {
    const filData = data.filter((ele) => ele.Parameter == Parameter)

    if (filData && filData?.length > 0)
      return filData[0].Mandatory.toLowerCase() == 'true' ? true : false;
    else
      return false
  }
  else
    return false
}

export const URIEncrypt = {
  Sale: "5envOAgVIY4C3AppqTIOQ==",
  Purchase: "AajKIeaOgKPSeDe3n9h1Q==",
  Polish: "ABF40G4rF0BTYceit5FgLA==",
  Rough: "RJZMdz5xYlPAEyPCqdGqeg==",
  Rejection: "aOKtLyyf7pa2I7ql8HGdtA==",
  SinglePacket: "J1uV3jz9q4Wz4L4KSZzirw==",
  Mix: "TyQE506fA9dJbvTP7PUuvw==",
  Receive: "lWYAoq7z3vmSG76yXvlWuw==",
  Payment: "VlTLnoBtRtoh2hmXsiFkFQ=="
}

export const getModValue = (Parameter, data) => {

  if (data && data.length > 0) {
    const filData = data.filter((ele) => ele.Parameter == Parameter)
    if (filData && filData?.length > 0)
      return filData[0].Value
    else
      return ""
  }
  else
    return ""
}

const linksUrl = {
  test: "/test",
  login: "/login",
  dashboard: {
    tradingDashboard: "/dashboard/trading-dashboard",
    masterDashboard: "/dashborad/costing-status-dashboard",
  },
  resetPassword: "/user/resetpassword",
  authenticationkey: "/settings/authenticationkey",

  master: {
    item: {
      itemMaster: "/master/item-master",
      createItemMaster: "/master/item/create-entry"
    },
    account: {
      accountMaster: "/master/account-master",
      createAccountMaster: "/master/account/create-entry",
      importAccount: "/master/account/import",

    },
    itemGroup: {
      itemGroupMaster: "/master/item-group-master",
      createItemGroupMaster: "/master/item-group/create-entry"
    },
    itemType: {
      itemTypeMaster: "/master/item-type-master",
      createItemTypeMaster: "/master/item-type/create-entry"
    },
    lot: {
      lotMaster: "/master/lot-master",
      createLotMaster: "/master/lot/create-entry"
    },


  },
  demand: {
    demandMaster: "/sales/demand-master",
    createDemandMaster: "/sales/demand/create-entry"
  },
  diamondParamater: {
    shape: {
      shapeMaster: "/diamparam/shape-master",
      createShapeMaster: "/diamparam/shape/create-shape"
    },
    cut: {
      cutMaster: "/diamparam/cut-master",
      createCutMaster: "/diamparam/cut/create-cut"
    },
    shade: {
      shadeMaster: "/diamparam/shade-master",
      createShadeMaster: "/diamparam/shade/create-shade"
    },
    purity: {
      purityMaster: "/diamparam/purity-master",
      createPurityMaster: "/diamparam/purity/create-purity"
    },
    size: {
      sizeMaster: "/diamparam/size-master",
      createSizeMaster: "/diamparam/size/create-size"
    },
    polishSize: {
      polishSizeMaster: "/diamparam/polish-size-master",
      createpolishSizeMaster: "/diamparam/create-polishsize"
    },
    flrn: {
      flrnMaster: "/diamparam/flrn-master",
      createFlrnMaster: "/diamparam/flrn/create-flrn"
    },
    lwmaster: {
      LWMaster: "/diamparam/lw-master"
    },
  },
  modSetting: {
    modSettingMaster: "/mod-settings",
    createmodSettingMaster: "/create-mod-settings",
    importBills: "/import-bills"
  },
  TemplateSettings: {
    excelTemplateMap: "/template-mapping",
  },

  salePurchaseEntry: "/diamond/",
  saleEntry: {
    polishDiamond: "/polishsdiam/",
    rejectDiamond: "/rejectsdiam/",
    roughDiamond: "/roughsdiam/",
  },
  purchaseEntry: {
    polishDiamond: "/polishpdiam/",
    rejectDiamond: "/rejectpdiam/",
    roughDiamond: "/roughpdiam/",
  },
  reportTemplate: {
    createEntry: "/report/template-assign",
    templateMaster: "/report-template"
  },
  outstandingBillEntry: {
    createBillEntry: "/transaction/outstanding-bill-entry",
    billEntryMaster: "/transaction/outstanding-bills"
  },
  mixEntry: "/mix",
  memoEntry: {
    memoEntryMaster: "/memo",
    createMemoEntry: "/memo/create-entry"
  },
  invoiceEntry: {
    invoiceEntryMaster: "/invoce",
    createInvoiceEntry: "/invoice/create-entry",
    genPurchaseEntryMaster: "/general-purchase/invoice",
    createGenPurchaseEntry: "/general-purchase-invoice/create-entry"
  },
  creditDebitEntry: {
    crDrNoteMaster: "/accunt/credit-debit-note",
    createEntry: "/acc/credit-debit-note/create-entry",


  },

  returnEntry: {

    returnEntryMaster: "/return",
    createReturnEntry: "/return/create-entry",
    invoiceReturnEntryMaster: "/return/invoice",
    createInvoiceReturnEntry: "/return/invoice-entry"
  },
  journalVoucherEntry: {
    createJournalVoucherEntry: "/journal-voucher/create-entry",
    journalVoucherEntryMaster: "/jv-entries"
  },
  packetTrasnferEntry: {
    createPktTransEntry: "/packettransfer-entry",
    packetTransferMaster: "/PacketTransfer",
    polishStock: '/packet-transfer-polish',
    roughStock: "/packet-transfer-rough",
    createmixEntry: "/mix-entry",
    entrymixMaster: "/mix",
    createsingleEntry: "/single-entry",
    entrysingleMaster: "/single"


  },
  stockEntry: {
    stockEntryMaster: "/stock",
    createStockEntry: "/stock/create-entry",
    polishDiamond: "/polishstockdiam/",
    roughDiamond: "/roughstockdiam/",
    rejectDiamond: "/rejectstockdiam/",
    getSingleStock: "/sstk-data",
    getMixStock: "/mstk-data",
    rptMixStockDetail: "/rpt-mstk/details",
    parameterUpdate: "/parameter-update",
    parameterUpdateEntry: "/parameter-update/entry",
    stockReport: "/reports/single-packet-stock-view",
    stockTally: "/stock/StockTally",
    barcodeGenerator: "/diamparam/BarcodeGenerator",
    singlePktPriceUpdate: "/stock/single-packet-price-update",
    updateLotCode: "/stock/update-code"

  },
  clientApiEntry: {
    createApiEntry: "/api-settings/create-entry",
    apiEntryMaster: "/api-settings"
  },
  mixslitEntry: {
    mixslitEntryMaster: "/mixsplit",
    createMixslitEntry: "/mixsplit/create-entry",
    polishDiamond: "/polishmxsldiam/",
    roughDiamond: "/roughmxsldiam/",
  },
  transactionEntry: "transaction",
  receiveEntry: {
    receive: "/transactionrec",
    createReceiveEntry: "/receive-entry",
    receiveEntryMaster: "/receive-transaction"

  },
  billOfEntry: "/bill-Of-Entry",
  priceListEntry: "/price-list-entry",
  importExportEntry: {
    createPayEntry: "/import-transaction",
    payEntryMaster: "/import-entry",
    pay: "/payment",
    createRecEntry: "/export-transaction",
    recEntryMaster: "/export-entry",
    rec: "/receive"
  },
  paymentEntry: {
    paymentEntryMaster: "/payment-transaction",
    createPaymentEntry: "/payment-entry",
    payment: "/transactionpay",
    paymentReport: "/reports/receive-payment-register"
  },
  outstanding: {
    receivable: {
      partySummary: "/outstanding/receivable/party-summary",
      partyAgingSummary: "/outstanding/receivable/party-aging-summary",
      partyDetail: "/outstanding/receivable/party-detail",
    },
    payable: {
      partySummary: "/outstanding/payable/party-summary",
      partyAgingSummary: "/outstanding/payable/party-aging-summary",
      partyDetail: "/outstanding/payable/party-detail",
    },
    interestCalc: "/Interest-Calcultion/",
    report: "/report/outstanding-report"
  },
  ledger: {
    get: "/ledger",
    getAccount: "/ledger/account",
  },
  multiCompLedger: {
    get: "/multi_ledger",
    getAccount: "/multi_ledger/account",
  },
  salesOrder: "/salesorder-summary",
  salesData: {
    getList: "/reports/trading-data",
    rptInvoice: "/invoice/report",
    detail: "/sales/detail",
    //memo:"/memo-sales/detail",
  },
  roughAllotment: {
    createAllotmentEntry: "/rough-allotment-entry",
    allotmentEntryMaster: "/rough-allotment"
  },
  gstReport: {
    mainGst: "/master/mainGst",
    GstLedger: "/master/getGstLedger",
    GstPeriodicSummary: "/master/GstPeriodicSummary",
    GstRegister: "/master/GstRegister"
  },
  userCompMaping: {
    get: "/user-company-maping"

  },
  utility: {
    accountSwapping: "/utility/swap-account"
  },
  monthClosing: {
    monthExpEntryMaster: "/monthly-expense",
    createEntry: "/monthly-expense/create-entry",
    monthClosingStock: "/monthly-closing-stock/create-entry",
    monthClosingStockMaster: "/monthly-closing-stock"
  },
  report: "/report",
  rptSinglePktLotWiseStock: "/singlepkt-lotwise-stock-position",
  rptSinglePktLotWiseStockDetail: "/singlepkt-lotwise-stock-details",
  rptSinglePktInwardStock: "/singlepkt-lotwise-inward-stock-position",

  rptParamwisePosition: "/report-paramswiseposition",
  rptLotwisePosition: "/report-lotwiseposition",
  rptLotwiseCosting: "/report-lotwisecosting",
  rptLotwiseDetail: "/report-lotwise-detail",
  rptPacketInfo: "/report-paktinfo",
  rptDebitCreditNote: "/debit-credit note",
  rptBalanceSheet: "/balance-sheet",
  rptProfitNLoss: "/profit-loss-report",
  rptTrialBalance: '/trial-balance-sheet',
  rptRoughStock: "/report-rough-wise-stock",
  rptMemoDetail: "/report-memo-detail",
  rptBankCashBook: "/report-bank-cash-detail",
  memoFinalizeEntry: "/memo-finalize",
  companies: "/",

}

export const ENUM_TRADE_TYPE = [{ t_type: "RD" }, { t_type: "URD" }, { t_type: "OGS" }]
const stateEnum = {
  company: "company",
  auth: "auth",
  item: "item",
  account: "account",
  memoEntry: "memoEntry",
  invoiceEntry: "invoiceEntry",
  finalizeEntry: "finalizeEntry",
  shape: "shape",
  shade: "shade",
  cut: "cut",
  purity: "purity",
  size: "size",
  flrn: "flrn",
  polishSize: "polishSize",
  lwmaster: "lwmaster",
  ledger: "ledger",
  stockEntry: "stockEntry",
  mixslitEntry: "mixslitEntry",
  receiveEntry: "receiveEntry",
  paymentEntry: "paymentEntry",
  outstandingReceivable: "outstandingReceivable",
  outstandingPayable: "outstandingPayable",
  stock: "stock",
  outstandingBillEntry: "outstandingBillEntry",
  pktTransfer: "pktTransfer",
  itemGroupEntry: "itemGroupEntry",
  itemTypeEntry: "itemTypeEntry",
  clientApiSetting: "clientApiSetting",
  roughAllotment: "roughAllotment",
  reportTemplate: "reportTemplate",
  lotMaster: "lotMaster",
  jvEntry: "jvEntry",
  returnEntry: "returnEntry",
  demandEntry: "demandEntry",
  monthClosingEntry: "monthClosingEntry",
  creditDebitNote: "creditDebitNote"
}

export const funGetSalePurURL = (billTYpe, tradeOf, entryType) => {
  return linksUrl.salePurchaseEntry + billTYpe + "/" + tradeOf + "/" + entryType + linksUrl.memoEntry.memoEntryMaster;
}

const apiRoute = {
  company: "/company",
  companyAcYear: "/company/ac-year",
  setAcYearId: "/company/set-yearid",
  resetPassword: "/user/reset-password",
  setWebAdmPassword: "/company/adm-webpwd",
  fetchAdmPassword: "/company/fetch-admpwd",
  dashboard: {
    getTradingData: "/dashboard/trading",
    getPurchaseData: "/dashboard/purchase",
    getSaleData: "/dashboard/sale",
    getOutstandingData: "/dashboard/outstanding",
  },
  item: {
    fetch: "/item/fetch-item",
    deleteitem: "/item/item-delete",
    masterData: "/item/master-data",
    fetchGstType: "/item/gst-type",
    addUpdate: "/item/add-update",
    checkItemCode: "/item/check-item-code"
  },
  itemGroup: {
    add_update: "/item-group/add-update",
    fetch: "/item-group/fetch-entry",
    deleteEntry: "/item-group/delete-entry",
    fetchEntryDetail: "/item-group/entry-detail",
    checkItgrCode: "/item-group/check-itgr-code"
  },
  reportTemplate: {
    add_update: "/rpt-template/add-update",
    fetch: "/rpt-template/fetch-entry",
    deleteEntry: "/rpt-template/delete-entry",
    fetchEntryDetail: "/rpt-template/entry-detail",
    fetchReportTemp: "/rpt-template/tempdata"
  },
  itemType: {
    add_update: "/item-type/add-update",
    fetch: "/item-type/fetch-entry",
    deleteEntry: "/item-type/delete-entry",
    fetchEntryDetail: "/item-type/entry-detail",
    checkItgrCode: "/item-type/check-itgr-code"
  },
  account: {
    fetch: "/account/fetch-account",
    deleteAccount: "/account/account-delete",
    masterTypeProcess: "/account/master-type-process",
    masterPartyTradeState: "/account/master-party-trade-state",
    checkacid: "/account/check-acid",
    add: "/account/add",
    fetchAcByType: "/account/account-by-type",
    addBroker: '/account/broker/add',
    fetchBroker: '/account/broker/fetch',
    addTransport: '/account/transport/add',
    fetchTransport: '/account/transport/fetch',
    addDelivery: '/account/delivery/add',
    fetchDelivery: '/account/delivery/fetch',
    verifyGstDetail: '/account/gst-verify',
    importAccounts: "/account/import-acc",
    fetchAllAccount: "/account/acc-list",
    swapAccount: "/account/swap-acc"
  },
  shape: {
    addupdateShape: "/shape/shape-add-update",
    getShape: "/shape/show-shapes",
    deleteShape: "/shape/shape-delete",
    checkShapeCode: "/shape/check-shape-code",
    getshapeforupdate: "/shape/shape-get-by-id",
    getNextSOrd: "/shape/getNextSOrd"
  },
  shade: {
    getshade: "/shade/show-shades",
    addupdateShade: "/shade/shade-add-update",
    deleteShade: "/shade/shade-delete",
    checkShadeCode: "/shade/check-shade-code",
    getshadeforupdate: "/shade/shade-get-by-id",
    getNextShOrd: "/shade/getNextShOrd"
  },
  cut: {
    getcut: "/cut/show-cuts",
    addupdateCut: "/cut/cut-add-update",
    deleteCut: "/cut/cut-delete",
    checkCutCode: "/cut/check-cut-code",
    getcutforupdate: "/cut/cut-get-by-id",
    getNextCutOrd: "/cut/getNextCutOrd"
  },

  purity: {
    getpurity: "/purity/show-purity",
    addupdatePurity: "/purity/purity-add-update",
    deletePurity: "/purity/purity-delete",
    checkPurityCode: "/purity/check-purity-code",
    getpurityforupdate: "/purity/purity-get-by-id",
    getNextQuaOrd: "/purity/getNextQuaOrd"
  },
  size: {
    GetPSize: "/size/show-size",
    AddUpdatePSize: "/size/size-add-update",
    CheckSzCode: "/size/check-size-code",
    deletePSize: "/size/size-delete",
    GetPSizeForUpdate: "/size/size-get-by-id",
    getNextSzOrd: "/size/getNextSzOrd"
  },
  polishSize: {
    fetch: "/polish-size/fetch",
    AddUpdate: "/polish-size/add-update",
    CheckSzCode: "/polish-size/check-szcode",
    deleteEntry: "/polish-size/delete-entry",
    fetchEntryDetail: "/polish-size/detail",
    getNextSzOrd: "/polish-size/next-szcode"
  },
  flrn: {
    getFlrn: "/flrn/show-flrn",
    AddUpdateFlrn: "/flrn/flrn-add-update",
    deleteFlrn: "/flrn/flrn-delete",
    checkFlrnCode: "/flrn/check-flrn-code",
    getFlrnForUpdate: "/flrn/flrn-get-by-id",
    getNextFlrnOrd: "/flrn/getNextFlrnOrd"
  },
  lwMaster: {
    getshape: "/lwmaster/get-shape-name",
    getLWMaster: "/lwmaster/get-LWMaster",
    deleteLWMaster: "/lwmaster/delete-LWMaster",
    insertLWMaster: "/lwmaster/insert-LWMaster",
    updateLWMaster: "/lwmaster/update-LWMaster"
  },
  lotMaster: {
    add_update: "/lotmaster/add-update",
    fetch: "/lotmaster/fetch-entry",
    deleteEntry: "/lotmaster/delete-entry",
    fetchEntryDetail: "/lotmaster/entry-detail",
    checkLotCode: "/lotmaster/check-lot-code"
  },
  demandMaster: {
    add_update: "/demand-entry/add-update",
    fetch: "/demand-entry/fetch-entry",
    deleteEntry: "/demand-entry/delete-entry",
    fetchEntryDetail: "/demand-entry/entry-detail",
    checkDemandNo: "/demand-entry/check-demno",
    entryMasterData: "/demand-entry/master-data",
    getReportData: "/demand-entry/rpt-data",
    funGenDemNo: "/demand-entry/gen-demno"
  },
  memoEntry: {
    generateVoucherNo: "/memo-entry/generate-vouno",
    add_update: "/memo-entry/add-update",
    fetch: "/memo-entry/fetch-entry",
    deleteEntry: "/memo-entry/delete-entry",
    fetchEntryDetail: "/memo-entry/entry-detail",
    checkChalNo: "/memo-entry/check-chalno",
    entryMasterData: "/memo-entry/master-data",
    gridMasterData: "/memo-entry/grid-master-data",
    checkLotPktNo: "/memo-entry/check-lotpktno",
    checkReportNo: "/memo-entry/check-reportno",
    checkRoughNo: "/memo-entry/check-roughno",
    fetchStockData: "/memo-entry/stock-data",
    fetchMixStock: "/memo-entry/mix-stock",
    fetchMemoData: "/memo-entry/fetch-memo",
    fetchMktlotNo: "/memo-entry/mktlotno",


    // checkRef: "/memo-entry/check-ref",
    checkRoughRef: "/memo-entry/check-refrough"
  },
  invoiceEntry: {
    generateVoucherNo: "/invoice-entry/generate-vouno",
    generateBillNo: "/invoice-entry/generate-billno",
    add_update: "/invoice-entry/add-update",
    fetch: "/invoice-entry/fetch-entry",
    deleteEntry: "/invoice-entry/delete-entry",
    fetchEntryDetail: "/invoice-entry/entry-detail",
    checkBillNo: "/invoice-entry/check-billno",
    entryMasterData: "/invoice-entry/master-data",
    gridMasterData: "/invoice-entry/grid-master-data",
    checkLotPktNo: "/invoice-entry/check-lotpktno",
    fetchStockData: "/invoice-entry/stock-data",
    fetchInvoiceData: "/invoice-entry/fetch-invoice",
    fetchMixStock: "/invoice-entry/mix-stock",
    fetchPartyBills: "/invoice-entry/party-bills",
    getStockByLotPkt: "/invoice-entry/billd-lotpkt",
    funImportBills: "/invoice-entry/import",
    getExportParams: "/invoice-entry/export-param",
    updateExportData: "/invoice-entry/export-update",
    getTermMasterData: "/invoice-entry/term-data",
    getLocation: "/invoice-entry/loc-data",
    getBillofData: "/invoice-entry/billof-data",
    updateBillOf: "/invoice-entry/billof-update",
  },
  generalPurchaseEntry: {
    add_update: "/general-purchase/add-update",
    fetch: "/general-purchase/fetch-entry",
    deleteEntry: "/general-purchase/delete-entry",
    fetchEntryDetail: "/general-purchase/entry-detail",
    checkBillNo: "/general-purchase/check-billno",
    entryMasterData: "/general-purchase/master-data",
  },
  finalizeEntry: {
    add_update: "/finalize-entry/add-update",
    chkFinalizeLotPkt: "/finalize-entry/chk-lotpkt",
  },
  stockTally: {
    getStockTellyData: "/stock-tally/fetch-stock",
    add_update: "/stock-tally/add-update",
    fetch: "/stock-tally/fetch-entry",
    deleteEntry: "/stock-tally/delete-entry"
  },
  stockEntry: {
    add_update: "/stock-entry/add-update",
    fetch: "/stock-entry/fetch-entry",
    deleteEntry: "/stock-entry/delete-entry",
    fetchEntryDetail: "/stock-entry/entry-detail",
    entryMasterData: "/stock-entry/master-data",
    getExcelTemplate: "/stock-entry/excel-template",
    fetchStock: "/stock-entry/fetch-stock",
    fetchMixStock: "/stock-entry/fetch-mixstock",
    fetchMasterData: "/stock-entry/fetch-master",
    updateParam: "/stock-entry/update-stock-param",
    getUpdateParamData: "/stock-entry/update-param-data",
    paramMasterData: "/stock-entry/param-master-data",
    reportMasterData: "/stock-entry/report-master-data",
    fetchReportStock: "/stock-entry/stock-report-data",

    fetchMixStokReport: "/stock-entry/mixstock-report-data",
    fetchLotWiseReport: "/stock-entry/lotwise-data",
    fetchLotWiseDetail: "/stock-entry/lot-detail",
    fetchPacketInfo: "/stock-entry/pkt-info",
    fetchPriceupData: "/stock-entry/fetchrateupdata",
    updatePrice: "/stock-entry/update-rate",
    fetchRoughStock: "/stock-entry/fetch-rghstock",
    getDupPktList: "/stock-entry/dup-pktlist",
    getNotExistLotPktList: "/stock-entry/notexist-pktlist",
    getLabList: "/stock-entry/lablist",
    getLotNosList: "/stock-entry/lotnos",
    getStockLocationList: "/stock-entry/stk-location",
    fetchLotStockDetail: "/stock-entry/lot-stock-detail",
    getUploadParamList: "/stock-entry/upload-params",
    fetchInwardData: "/stock-entry/inw-data",
    updateLotCode: "/stock-entry/update-lotcode",
    getOutStockLotPkt: "/stock-entry/outstock-lotpkt",
    getStoneAgeData: "/stock-entry/stone-age",
    findStokeWithPosition: "/stock-entry/find-stkwtpos",
    getLotWiseCosting: "/stock-entry/lot-costing",
    getParamWiseData: "/stock-entry/data-paramwise",
    chkPktRefSale: "/stock-entry/chkref-pktsale",


  },
  polishRateEntry: {
    addUpdate: "/polish-rate/add-update",
    getPrDate: "/polish-rate/get-prdate",
    fetch: "/polish-rate/entry-data",
    deleteEntry: "/polish-rate/delete-entry",
    updatePRate: "/polish-rate/update-prate",
    getMaxDateData: "/polish-rate/max-prdate",
    getPriceType: "/polish-rate/price-type",


  },
  monthClosing: {
    fetchMasterData: "/month-entry/master-data",
    add_update: "/month-entry/add-update",
    fetchEntry: "/month-entry/fetch",
    fetchEntryDetail: "/month-entry/detail",
    deleteEntry: "/month-entry/delete-entry",
    fetchAcc: "/month-entry/acc",
    mcsAddupdate: "/month-entry/mcs-addup",
    mcsFetchEntry: "/month-entry/mcs-fetch",
    mcsDeleteEntry: "/month-entry/mcs-delete"
  },
  creditDebitNote: {
    add: "/credit-debit-note/add-update",
    fetchInvoice: "/credit-debit-note/fetch",
    fetchInvoiceDetail: "/credit-debit-note/detail",
    fetchMasterData: "/credit-debit-note/master-data",
    generateVouNo: "/credit-debit-note/generate-vouno",
    deleteEntry: "/credit-debit-note/delete-note",
    fetchBillNo: "/credit-debit-note/fetch-billno",
    fetchEntry: "/credit-debit-note/fetch",
  },
  clientApiSetting: {
    add_update: "/clientapi/add-update",
    deleteEntry: "/clientapi/delete-entry",
    fetch: "/clientapi/fetch",
    checkClientName: "/clientapi/check-clientname",
    fetchApiUser: "/user/api-user"
  },
  gstReport: {
    getGstLedger: "/gstreport/getGstLedger",
    GstPeriodicSummary: "/gstreport/GstPeriodicSummary",
    GstRegister: "/gstreport/GSTRegisterSummary"
  },

  roughAllotmentEntry: {
    add_update: "/rough-allotment/add-update",
    deleteEntry: "/rough-allotment/delete-entry",
    fetch: "/rough-allotment/fetch",
    entryMasterData: "/rough-allotment/master-data",
    fetchEntryDetail: "/rough-allotment/entry-detail",
    diamParamData: "/rough-allotment/diam-param-data",
    checkRoughNo: "/rough-allotment/chk-roughno",
    checkLotNo: "/rough-allotment/chk-lotno",
  },
  modSetting: {
    masterModList: "/mod-setting/mod-list",
    fetchModData: "/mod-setting/mod-data",
    add: "/mod-setting/add",
    update: "/mod-setting/update",
    getAppType: "/mod-setting/app-type",
    getModSetting: "/mod-setting/get-setting",
    getMultiModSetting: "/mod-setting/get-multi-setting"

  },
  mixslitEntry: {
    generateVoucherNo: "/mixslit-entry/generate-vouno",
    add_update: "/mixslit-entry/add-update",
    fetch: "/mixslit-entry/fetch-entry",
    deleteEntry: "/mixslit-entry/delete-entry",
    fetchEntryDetail: "/mixslit-entry/entry-detail",
    entryMasterData: "/mixslit-entry/master-data",
    // fetchStockData: "/mixslit-entry/stock-data",
    //fetchMixStock: "/mixslit-entry/mix-stock",
  },
  mapping: {
    inserttemplete: "/mapping/template-add",
    getTemp: "/mapping/show-templete",
    checkTempname: "/mapping/check-tempname",
    GetTnameForUpdate: "/mapping/temp-get-by-id",
    updateTemp: "/mapping/temp-update",
    deleteTemp: "/mapping/temp-delete",
    GetExcelTemp: "/mapping/GetExcelTemp",
    updateExcelTemplate: "/mapping/updateExcelTemplate",
    insertExcelTemplate: "/mapping/insertExcelTemplate",
    //  updateExcelTemplate: "/mapping/updateExcelTemplate",
    //insertExcelTemplate: "/mapping/insertExcelTemplate",
    deleteExcelTemplate: "/mapping/deleteExcelTemplate",
    importExcelData: "/mapping/importExcelData"
  },
  journalVoucherEntry: {
    entryMasterData: "/journal-voucher/entry-master-data",
    add_update: "/journal-voucher/add-update",
    fetchEntry: "/journal-voucher/fetch",
    fetchEntryDetail: "/journal-voucher/fetch-detail",
    generateJvVouNo: "/journal-voucher/generate-jvvouno",
    deleteEntry: "/journal-voucher/delete-entry"
  },
  transactionEntry: {
    fetchMasterData: "/recpay-entry/master-data",
    add_update: "/recpay-entry/add-update",
    fetch: "/recpay-entry/fetch-entry",
    fetchEntryDetail: "/recpay-entry/detail",
    deleteEntry: "/recpay-entry/delete-entry",
    getBill: "/recpay-entry/get-bills",
    getReportData: "/recpay-entry/pay-report",
    getParties: "/recpay-entry/getparties",
    insertOutstandingBill: '/recpay-entry/insert-outstanding-bill',
    getBrokerList: "/recpay-entry/broker-list",
    getPartyList: "/recpay-entry/party-list",
    getOutstandingBills: "/recpay-entry/outstanding-bills",
    updateOutstandingBill: "/recpay-entry/update-outstanding-bill",
    deleteOutstandingBill: "/recpay-entry/delete-outstanding-bill",
    inup_impexp_entry: "/recpay-entry/inup-impexp-entry",
    fetchImpExpEntryDetail: "/recpay-entry/impexp-detail",
    getCreditDebitData: "/recpay-entry/crdr-data",
    getTrialBalanceData: "/recpay-entry/tb-data",
    getProfitLossData: "/recpay-entry/pnl-data",
    getOtheraAcc: "/recpay-entry/other-acc",
    getBankCashData: "/recpay-entry/bankcash-data",
  },
  outstanding: {
    partySummary: "/outstanding/summary",
    partyDetail: "/outstanding/detail",
    partyAgingSummary: "/outstanding/aging-summary",
    partyInfo: "/outstanding/party/info",
    partyBrokerInfo: "/outstanding/party/info-broker",
    partyBills: "/outstanding/interest-calc/bills-info",
    masterData: "/outstanding/master-data",
    getReportData: "/outstanding/getpartiesdetail",
    getAccount: "/outstanding/getaccount"
  },
  userCompMaping: {
    masterData: "/usercomp-maping/master-data",
    addUpdate: "/usercomp-maping/add-update",
    getUserMaping: "/usercomp-maping/user-maping"
  },
  ledger: {
    fetch: "/ledger",
    account: {
      fetch: "/ledger/account",
    },
    accountType: "/ledger/account-type",
    multiAccount: {
      fetch: "/ledger/multi-account-ledger"
    },
    multiLedger: {
      fetch: "/ledger/multi-ledger"
    }
  },
  salesOrder: {
    fetch: "/sales/sales-order",
    fetchPartyMasterData: "/sales/party-master",
    fetchMasterData: "/sales/master-data",
  },
  salesData: {
    fetch: "/sales",
    fetchInvoiceDetail: "/sales/detail",
    fetchAccount: "/sales/account-master",
    getData: '/sales/getdata',
    getParties: '/sales/getparties',
    getMemoData: "/sales/memo-data",

  },
  packetTransferEntry: {
    getAccount: "/packet-transfer/getAccount",
    GenerateVouNo: "/packet-transfer/GenerateVouNo",
    getToLocation: "/packet-transfer/getToLocation",
    getFromLocation: "/packet-transfer/getFromLocation",
    getPurposeList: "/packet-transfer/getPurposeList",
    getStockData: "/packet-transfer/getStockData",
    InsertUpdatePktTransfer: "/packet-transfer/InsertUpdatePktTransfer",
    getChallanSummary: "/packet-transfer/getChallanSummary",
    getEntryDetail: "/packet-transfer/getEntryDetail",
    deletePktChalData: "/packet-transfer/deletePktChalData",
    entryMasterData: "/packet-transfer/master-data",
    chkStockLocation: "/packet-transfer/chk-stkat",

  }
}

const sideNavLinks = [
  {
    name: "Company",
    key: "Companies",
    icon: faBuildingUser,
    color: "text-lime-700",
    url: linksUrl.companies,
  },

  {
    name: "Dashboard",
    key: "Dashboard",
    color: "text-orange-700",
    icon: faDashboard,
    url: linksUrl.dashboard.tradingDashboard,
  },
  {
    name: "Master",
    key: "Master",
    icon: faBarsProgress,
    color: "text-purple-700",
    sub: [
      {
        name: "Account",
        key: "AccountMaster",
        icon: faAnglesRight,
        url: linksUrl.master.account.accountMaster,
      },

      {
        name: "Lot Master",
        key: "LotMasterEntry",
        icon: faAnglesRight,
        url: linksUrl.master.lot.lotMaster,
      },
      {
        name: "Item",
        key: "ItemMaster",
        icon: faAnglesRight,
        url: linksUrl.master.item.itemMaster,
      },
      {
        name: "Item Group",
        key: "ItemGroupMaster",
        icon: faAnglesRight,
        url: linksUrl.master.itemGroup.itemGroupMaster,
      },
      {
        name: "Item Type",
        key: "ItemTypeMaster",
        icon: faAnglesRight,
        url: linksUrl.master.itemType.itemTypeMaster,
      },
      {
        name: "Polish Price",
        key: "PolishPriceEntry",
        icon: faAnglesRight,
        url: linksUrl.priceListEntry
      },

    ]
  },
  {
    name: "Diamond Parameter",
    key: "DiamondParameter",
    icon: faDiamondTurnRight,
    color: "text-yellow-700",
    sub: [

      {
        name: "Shape",
        key: "ShapeMaster",
        icon: faAnglesRight,
        url: linksUrl.diamondParamater.shape.shapeMaster,
      },
      {
        name: "Color",
        key: "ShadeMaster",
        icon: faAnglesRight,
        url: linksUrl.diamondParamater.shade.shadeMaster,
      },
      {
        name: "Purity",
        key: "PurityMaster",
        icon: faAnglesRight,
        url: linksUrl.diamondParamater.purity.purityMaster,
      },
      {
        name: "Size",
        key: "SizeMaster",
        icon: faAnglesRight,
        url: linksUrl.diamondParamater.size.sizeMaster,
      },
      {
        name: "Cut",
        key: "CutMaster",
        icon: faAnglesRight,
        url: linksUrl.diamondParamater.cut.cutMaster,
      },
      {
        name: "Flrn",
        key: "FluorescentMaster",
        icon: faAnglesRight,
        url: linksUrl.diamondParamater.flrn.flrnMaster,
      },
      {
        name: "Polish Size",
        key: "PolishSizeMaster",
        icon: faAnglesRight,
        url: linksUrl.diamondParamater.polishSize.polishSizeMaster,
      },
      {
        name: "L/W ",
        key: "LWMaster",
        icon: faAnglesRight,
        url: linksUrl.diamondParamater.lwmaster.LWMaster
      },
      {
        name: "Barcode print",
        key: "BarcodePrint",
        icon: faBarcode,
        color: "text-orange-700",
        url: linksUrl.stockEntry.barcodeGenerator
      },

    ]
  },
  {
    name: "Stock",
    key: "Stock",
    icon: faCubesStacked,
    color: "text-pink-700",
    sub: [
      {
        name: "Rough Diamond",
        key: "StockRoughDiamond",
        icon: faArrowDownWideShort,
        sub: [
          {
            name: "Single Packet",
            key: "StockRoughEntrySingle",
            icon: faAnglesRight,
            url: linksUrl.stockEntry.roughDiamond + URIEncrypt.Rough + "/" + URIEncrypt.SinglePacket + linksUrl.stockEntry.stockEntryMaster,
          },
          {
            name: "Mix",
            key: "StockRoughEntryMix",
            icon: faAnglesRight,
            url: linksUrl.stockEntry.roughDiamond + URIEncrypt.Rough + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.stockEntry.stockEntryMaster,
          },

        ]
      },
      {
        name: "Polish Diamond",
        key: "StockPolishDiamond",
        icon: faArrowDownWideShort,
        sub: [
          {
            name: "Single Packet",
            key: "StockPolishEntrySingle",
            icon: faAnglesRight,
            url: linksUrl.stockEntry.polishDiamond + URIEncrypt.Polish + "/" + URIEncrypt.SinglePacket + linksUrl.stockEntry.stockEntryMaster
          },
          {
            name: "Mix",
            key: "StockPolishEntryMix",
            icon: faAnglesRight,
            url: linksUrl.stockEntry.polishDiamond + URIEncrypt.Polish + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.stockEntry.stockEntryMaster,
          },
          {
            name: "Parameter Update",
            key: "StockParameterUpdate",
            icon: faAnglesRight,
            url: linksUrl.stockEntry.polishDiamond + URIEncrypt.Polish + "/" + URIEncrypt.SinglePacket + linksUrl.stockEntry.parameterUpdate,
          },
          {
            name: "Single Packet Price Update",
            key: "SinglePacketPriceUpdate",
            icon: faAnglesRight,
            url: linksUrl.stockEntry.singlePktPriceUpdate,
          },
        ]
      },
      {
        name: "Rejection Diamond",
        key: "StockRejectionDiamond",
        icon: faArrowDownWideShort,
        sub: [
          {
            name: "Single Packet",
            key: "StockRejectionEntrySingle",
            icon: faAnglesRight,
            url: linksUrl.stockEntry.rejectDiamond + URIEncrypt.Rejection + "/" + URIEncrypt.SinglePacket + linksUrl.stockEntry.stockEntryMaster
          },
          {
            name: "Mix",
            key: "StockRejectionEntryMix",
            icon: faAnglesRight,
            url: linksUrl.stockEntry.rejectDiamond + URIEncrypt.Rejection + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.stockEntry.stockEntryMaster,
          }
        ]
      },
      {
        name: "Rough Allotment",
        key: "RoughAllotment",
        icon: faBoxesPacking,
        color: "text-orange-700",
        url: linksUrl.roughAllotment.allotmentEntryMaster,
      },
      {
        name: "Stock Tally",
        key: "StockTally",
        icon: faCheckToSlot,
        color: "text-orange-700",
        url: linksUrl.stockEntry.stockTally,
      },
      {
        name: "Update Lot No. / Pkt No.",
        key: "UpdateLotCodePktNo",
        icon: faPenToSquare,
        color: "text-orange-700",
        url: linksUrl.stockEntry.updateLotCode,
      },

    ]

  },
  {
    name: "Sale",
    key: "Sale",
    icon: faDiceD20,
    color: "text-emerald-700",
    sub: [

      {
        name: "Rough Diamond",
        key: "SaleRoughDiamond",
        icon: faArrowDownWideShort,
        sub: [
          {
            name: "Memo",
            key: "SaleMemoEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "SaleRoughMemoEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.roughDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Rough + "/" + URIEncrypt.SinglePacket + linksUrl.memoEntry.memoEntryMaster
              },
              {
                name: "Mix",
                key: "SaleRoughMemoEntryMix",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.roughDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Rough + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.memoEntry.memoEntryMaster,
              }
            ]

          },
          {
            name: "Memo Return",
            key: "SaleReturnEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "SaleRoughReturnEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.roughDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Rough + "/" + URIEncrypt.SinglePacket + linksUrl.returnEntry.returnEntryMaster
              },
              {
                name: "Mix",
                key: "SaleRoughReturnEntryMix",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.roughDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Rough + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.returnEntry.returnEntryMaster,
              }
            ]

          },
          {
            name: "Invoice Return",
            key: "SaleReturnEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "SaleRoughReturnEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.roughDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Rough + "/" + URIEncrypt.SinglePacket + linksUrl.returnEntry.invoiceReturnEntryMaster
              },
              {
                name: "Mix",
                key: "SaleRoughReturnEntryMix",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.roughDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Rough + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.returnEntry.invoiceReturnEntryMaster,
              }
            ]

          },
          {
            name: "Invoice",
            key: "SaleInvoiceEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "SaleRoughInvoiceEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.roughDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Rough + "/" + URIEncrypt.SinglePacket + linksUrl.invoiceEntry.invoiceEntryMaster,
              },
              {
                name: "Mix",
                key: "SaleRoughInvoiceEntryMix",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.roughDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Rough + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.invoiceEntry.invoiceEntryMaster,
              }
            ]

          },


        ]
      },
      {
        name: "Polish Diamond",
        key: "SalePolishDiamond",
        icon: faArrowDownWideShort,
        sub: [
          {
            name: "Memo",
            key: "SaleMemoEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "SalePolishMemoEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.polishDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Polish + "/" + URIEncrypt.SinglePacket + linksUrl.memoEntry.memoEntryMaster,
              },
              {
                name: "Mix",
                key: "SalePolishMemoEntryMix",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.polishDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Polish + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.memoEntry.memoEntryMaster,
              }
            ]

          },
          {
            name: "Memo Return",
            key: "SaleReturnEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "SalePolishReturnEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.polishDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Polish + "/" + URIEncrypt.SinglePacket + linksUrl.returnEntry.returnEntryMaster
              },
              {
                name: "Mix",
                key: "SalePolishReturnEntryMix",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.polishDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Polish + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.returnEntry.returnEntryMaster,
              }
            ]

          },
          {
            name: "Invoice Return",
            key: "SaleReturnEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "SalePolishReturnEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.polishDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Polish + "/" + URIEncrypt.SinglePacket + linksUrl.returnEntry.invoiceReturnEntryMaster
              },
              {
                name: "Mix",
                key: "SalePolishReturnEntryMix",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.polishDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Polish + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.returnEntry.invoiceReturnEntryMaster,
              }
            ]

          },
          {
            name: "Invoice",
            key: "SaleInvoiceEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "SalePolishInvoiceEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.polishDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Polish + "/" + URIEncrypt.SinglePacket + linksUrl.invoiceEntry.invoiceEntryMaster,
              },
              {
                name: "Mix",
                key: "SalePolishInvoiceEntryMix",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.polishDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Polish + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.invoiceEntry.invoiceEntryMaster,
              }
            ]

          },

        ]
      },
      {
        name: "Rejection Diamond",
        key: "SaleRejectionDiamond",
        icon: faArrowDownWideShort,
        sub: [
          {
            name: "Memo",
            key: "SaleMemoEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "SaleRejectionMemoEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.rejectDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Rejection + "/" + URIEncrypt.SinglePacket + linksUrl.memoEntry.memoEntryMaster,
              },
              {
                name: "Mix",
                key: "SaleRejectionMemoEntryMix",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.rejectDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Rejection + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.memoEntry.memoEntryMaster,
              }
            ]
          },
          {
            name: "MemoReturn",
            key: "SaleReturnEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "SaleRejectionReturnEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.rejectDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Rejection + "/" + URIEncrypt.SinglePacket + linksUrl.returnEntry.returnEntryMaster
              },
              {
                name: "Mix",
                key: "SaleRejectionReturnEntryMix",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.rejectDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Rejection + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.returnEntry.returnEntryMaster,
              }
            ]

          },
          {
            name: "Invoice Return",
            key: "SaleReturnEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "SaleRejectionReturnEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.rejectDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Rejection + "/" + URIEncrypt.SinglePacket + linksUrl.returnEntry.invoiceReturnEntryMaster
              },
              {
                name: "Mix",
                key: "SaleRejectionReturnEntryMix",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.rejectDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Rejection + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.returnEntry.invoiceReturnEntryMaster,
              }
            ]

          },
          {
            name: "Invoice",
            key: "SaleInvoiceEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "SaleRejectionInvoiceEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.rejectDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Rejection + "/" + URIEncrypt.SinglePacket + linksUrl.invoiceEntry.invoiceEntryMaster,
              },
              {
                name: "Mix",
                key: "SaleRejectionInvoiceEntryMix",
                icon: faAnglesRight,
                url: linksUrl.saleEntry.rejectDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Rejection + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.invoiceEntry.invoiceEntryMaster,
              }
            ]

          },

        ]
      },
      {
        name: "Demand Generation",
        key: "DemandGeneration",
        icon: faAnglesRight,
        url: linksUrl.demand.demandMaster,
      },
    ]
  },
  {
    name: "Purchase",
    key: "Purchase",
    icon: faCartShopping,
    color: "text-red-700",
    sub: [
      {
        name: "Rough Diamond",
        key: "PurchaseRoughDiamond",
        icon: faArrowDownWideShort,
        sub: [
          {
            name: "Memo",
            key: "PurchaseMemoEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "PurchaseRoughMemoEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.roughDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Rough + "/" + URIEncrypt.SinglePacket + linksUrl.memoEntry.memoEntryMaster,
              },
              {
                name: "Mix",
                key: "PurchaseRoughMemoEntryMix",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.roughDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Rough + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.memoEntry.memoEntryMaster,
              }
            ]
          },
          {
            name: "Memo Return",
            key: "PurchaseReturnEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "PurchaseRoughReturnEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.roughDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Rough + "/" + URIEncrypt.SinglePacket + linksUrl.returnEntry.returnEntryMaster
              },
              {
                name: "Mix",
                key: "PurchaseRoughReturnEntryMix",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.roughDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Rough + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.returnEntry.returnEntryMaster,
              }
            ]

          },
          {
            name: "Invoice Return",
            key: "PurchaseReturnEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "PurchaseRoughReturnEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.roughDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Rough + "/" + URIEncrypt.SinglePacket + linksUrl.returnEntry.invoiceReturnEntryMaster
              },
              {
                name: "Mix",
                key: "PurchaseRoughReturnEntryMix",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.roughDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Rough + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.returnEntry.invoiceReturnEntryMaster,
              }
            ]

          },
          {
            name: "Invoice",
            key: "PurchaseInvoiceEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "PurchaseRoughInvoiceEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.roughDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Rough + "/" + URIEncrypt.SinglePacket + linksUrl.invoiceEntry.invoiceEntryMaster,
              },
              {
                name: "Mix",
                key: "PurchaseRoughInvoiceEntryMix",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.roughDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Rough + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.invoiceEntry.invoiceEntryMaster,
              }
            ]
          },

        ]
      },
      {
        name: "Polish Diamond",
        key: "PurchasePolishDiamond",
        icon: faArrowDownWideShort,
        sub: [
          {
            name: "Memo",
            key: "PurchaseMemoEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "PurchasePolishMemoEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.polishDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Polish + "/" + URIEncrypt.SinglePacket + linksUrl.memoEntry.memoEntryMaster,
              },
              {
                name: "Mix",
                key: "PurchasePolishMemoEntryMix",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.polishDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Polish + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.memoEntry.memoEntryMaster,
              }
            ]

          },
          {
            name: "Memo Return",
            key: "PurchaseReturnEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "PurchasePolishReturnEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.polishDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Polish + "/" + URIEncrypt.SinglePacket + linksUrl.returnEntry.returnEntryMaster
              },
              {
                name: "Mix",
                key: "PurchasePolishReturnEntryMix",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.polishDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Polish + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.returnEntry.returnEntryMaster,
              }
            ]

          },
          {
            name: "Invoice Return",
            key: "PurchaseReturnEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "PurchasePolishReturnEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.polishDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Polish + "/" + URIEncrypt.SinglePacket + linksUrl.returnEntry.invoiceReturnEntryMaster
              },
              {
                name: "Mix",
                key: "PurchasePolishReturnEntryMix",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.polishDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Polish + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.returnEntry.invoiceReturnEntryMaster,
              }
            ]

          },

          {
            name: "Invoice",
            key: "PurchaseInvoiceEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "PurchasePolishInvoiceEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.polishDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Polish + "/" + URIEncrypt.SinglePacket + linksUrl.invoiceEntry.invoiceEntryMaster,
              },
              {
                name: "Mix",
                key: "PurchasePolishInvoiceEntryMix",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.polishDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Polish + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.invoiceEntry.invoiceEntryMaster,
              }
            ]

          },

        ]
      },
      {
        name: "Rejection Diamond",
        key: "PurchaseRejectionDiamond",
        icon: faArrowDownWideShort,
        sub: [
          {
            name: "Memo",
            key: "PurchaseMemoEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "PurchaseRejectionMemoEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.rejectDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Rejection + "/" + URIEncrypt.SinglePacket + linksUrl.memoEntry.memoEntryMaster,
              },
              {
                name: "Mix",
                key: "PurchaseRejectionMemoEntryMix",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.rejectDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Rejection + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.memoEntry.memoEntryMaster,
              }
            ]
          },
          {
            name: "Memo Return",
            key: "PurchaseReturnEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "PurchaseRejectionReturnEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.rejectDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Rejection + "/" + URIEncrypt.SinglePacket + linksUrl.returnEntry.returnEntryMaster
              },
              {
                name: "Mix",
                key: "PurchaseRejectionReturnEntryMix",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.rejectDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Rejection + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.returnEntry.returnEntryMaster,
              }
            ]

          },
          {
            name: "Invoice Return",
            key: "PurchaseReturnEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "PurchaseRejectionReturnEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.rejectDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Rejection + "/" + URIEncrypt.SinglePacket + linksUrl.returnEntry.invoiceReturnEntryMaster
              },
              {
                name: "Mix",
                key: "PurchaseRejectionReturnEntryMix",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.rejectDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Rejection + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.returnEntry.invoiceReturnEntryMaster,
              }
            ]

          },
          {
            name: "Invoice",
            key: "PurchaseInvoiceEntry",
            icon: faRightToBracket,
            sub: [
              {
                name: "Single Packet",
                key: "PurchaseRejectionInvoiceEntrySingle",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.rejectDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Rejection + "/" + URIEncrypt.SinglePacket + linksUrl.invoiceEntry.invoiceEntryMaster,
              },
              {
                name: "Mix",
                key: "PurchaseRejectionInvoiceEntryMix",
                icon: faAnglesRight,
                url: linksUrl.purchaseEntry.rejectDiamond + URIEncrypt.Purchase + "/" + URIEncrypt.Rejection + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.invoiceEntry.invoiceEntryMaster,
              }
            ]
          },

        ]
      },
      {
        name: "GeneralPurchase",
        key: "GeneralPurchase",
        icon: faArrowDownWideShort,
        sub: [
          {
            name: "Invoice",
            key: "GeneralPurchaseInvoiceEntry",
            icon: faRightToBracket,
            url: linksUrl.invoiceEntry.genPurchaseEntryMaster
          },
        ]
      }
    ]
  },
  {
    name: "Mix-Split",
    key: "MixSlit",
    icon: faGroupArrowsRotate,
    color: "text-cyan-700",
    sub: [
      {
        name: "Rough Diamond",
        key: "MixSlitRoughDiamond",
        icon: faArrowDownWideShort,
        sub: [
          {
            name: "Single Packet",
            key: "MixSlitRoughEntrySingle",
            icon: faAnglesRight,
            url: linksUrl.mixslitEntry.roughDiamond + URIEncrypt.Rough + "/" + URIEncrypt.SinglePacket + linksUrl.mixslitEntry.mixslitEntryMaster,
          },
          {
            name: "Mix",
            key: "MixSlitRoughEntryMix",
            icon: faAnglesRight,
            url: linksUrl.mixslitEntry.roughDiamond + URIEncrypt.Rough + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.mixslitEntry.mixslitEntryMaster,
          }
        ]
      },
      {
        name: "Polish Diamond",
        key: "MixSlitPolishDiamond",
        icon: faArrowDownWideShort,
        sub: [
          {
            name: "Single Packet",
            key: "MixSlitPolishEntrySingle",
            icon: faAnglesRight,
            url: linksUrl.mixslitEntry.polishDiamond + URIEncrypt.Polish + "/" + URIEncrypt.SinglePacket + linksUrl.mixslitEntry.mixslitEntryMaster
          },
          {
            name: "Mix",
            key: "MixSlitPolishEntryMix",
            icon: faAnglesRight,
            url: linksUrl.mixslitEntry.polishDiamond + URIEncrypt.Polish + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.mixslitEntry.mixslitEntryMaster,
          }
        ]
      },


    ]

  },
  {
    name: "Account",
    key: "Account",
    icon: faBrazilianRealSign,
    color: "text-green-700",
    sub: [
      {
        name: "Receive Transaction",
        key: "ReceiveEntry",
        icon: faAnglesRight,
        url: linksUrl.receiveEntry.receive + "/" + URIEncrypt.Receive + linksUrl.receiveEntry.receiveEntryMaster
      },
      {
        name: "Payment Transaction",
        key: "PaymentEntry",
        icon: faAnglesRight,
        url: linksUrl.paymentEntry.payment + "/" + URIEncrypt.Payment + linksUrl.paymentEntry.paymentEntryMaster
      },
      {
        name: "Credit-Debit Note",
        key: "CreditDebitNoteEntry",
        icon: faAnglesRight,
        url: linksUrl.creditDebitEntry.crDrNoteMaster
      },
      {
        name: "Outstanding Bills Entry",
        key: "OutstandingBillEntry",
        icon: faAnglesRight,
        url: linksUrl.outstandingBillEntry.billEntryMaster
      },
      {
        name: "Payment Against Import",
        key: "PaymentAgainstImport",
        icon: faAnglesRight,
        url: linksUrl.importExportEntry.pay + "/" + URIEncrypt.Payment + linksUrl.importExportEntry.payEntryMaster
      },
      {
        name: "Receive Against Export",
        key: "ReceiveAgainstExport",
        icon: faAnglesRight,
        url: linksUrl.importExportEntry.rec + "/" + URIEncrypt.Receive + linksUrl.importExportEntry.recEntryMaster
      },
      {
        name: "Bill Of Entry",
        key: "BillOfEntry",
        icon: faAnglesRight,
        url: linksUrl.billOfEntry
      },
      {
        name: "JV Entry",
        key: "JournalVoucherEntry",
        icon: faAnglesRight,
        url: linksUrl.journalVoucherEntry.journalVoucherEntryMaster
      },


    ]
  },
  {
    name: "Reports & View",
    key: "ReportsAndViews",
    icon: faFileSignature,
    color: "text-pink-700",
    sub: [
      {
        name: "Account Reports",
        key: "FinalReports",
        icon: faMoneyCheckDollar,
        // color:"text-red-700",
        sub: [
          {
            name: "Ledger",
            key: "Ledgers",
            icon: faAnglesRight,// faFileEdit,
            // color: "text-orange-700",
            url: linksUrl.ledger.get,
          },
          {
            name: "Receive / Payment List",
            key: "PaymentReport",
            icon: faAnglesRight,// faMoneyCheckDollar,
            // color: "text-orange-700",
            url: linksUrl.paymentEntry.paymentReport,
          },

          {
            name: "Bank / Cash Book",
            key: "BankCashBookReport",
            icon: faAnglesRight,
            url: linksUrl.rptBankCashBook,
          },
          {
            name: "Debit Credit Note",
            key: "DebitCreditNoteReport",
            icon: faAnglesRight,
            url: linksUrl.rptDebitCreditNote,
          },
        ]
      },
      {
        name: "Outstanding",
        key: "Outstanding",
        icon: faFileInvoiceDollar,
        sub: [
          {
            name: "Receivable",
            key: "OutReceivable",
            icon: faAnglesRight,
            url: linksUrl.outstanding.receivable.partySummary,
          },
          {
            name: "Payable",
            key: "OutPayable",
            icon: faAnglesRight,
            url: linksUrl.outstanding.payable.partySummary,
          },


        ],
      },
      {
        name: "Final  Reports",
        key: "FinalReports",
        icon: faFileLines,
        sub: [

          {
            name: "Trial Balance Sheet",
            key: "TrialBalanceReport",
            icon: faAnglesRight,
            url: linksUrl.rptTrialBalance,
          },
          {
            name: 'Profit & Loss',
            key: "ProfitLossReport",
            icon: faAnglesRight,
            url: linksUrl.rptProfitNLoss,
          },
          {
            name: "Monthly Closing",
            key: "MonthlyClosingEntry",
            icon: faAnglesRight,
            url: linksUrl.monthClosing.monthClosingStock,
          },
          {
            name: "Balance Sheet",
            key: "BalanceSheetReport",
            icon: faAnglesRight,
            url: linksUrl.rptBalanceSheet,
          },

        ],
      },
      {
        name: "Stock",
        key: "StockReport",
        icon: faDiamond,
        sub: [
          {
            name: "Single",
            key: "StockReportSingle",
            icon: faAnglesRight,
            url: linksUrl.stockEntry.getSingleStock + "/single",
          },
          {
            name: "Mix",
            key: "StockReportMix",
            icon: faAnglesRight,
            url: linksUrl.stockEntry.getMixStock + "/mix",
          },
          {
            name: "Rough Wise Stock",
            key: "RoughWiseStockReport",
            icon: faAnglesRight,
            //color: "text-orange-700",
            url: linksUrl.rptRoughStock,
          },
          {
            name: "Shape/Size/Purity Wise Stock",
            key: "ParameterWiseStockSummary",
            icon: faAnglesRight,
            // color: "text-orange-700",
            url: linksUrl.rptParamwisePosition,
          },

        ],
      },
      {
        name: "Trading Report",
        key: "TradingReport",
        icon: faAddressBook,
        sub: [

          {
            name: "Trading Report",
            key: "TradingReport",
            icon: faAnglesRight,
            // color: "text-orange-700",
            url: linksUrl.salesData.getList,
          },
          {
            name: "Memo List",
            key: "MemoListReport",
            icon: faAnglesRight,
            //color: "text-orange-700",
            url: linksUrl.rptMemoDetail,
          },
        ]
      },
      {
        name: "LotWisePosition",
        key: "LotWisePositionReport",
        icon: faRankingStar,
        color: "text-orange-700",
        url: linksUrl.rptLotwisePosition,
      },

      {
        name: "Single Packet Lot Wise Stock",
        key: "SinglePacketLotWiseStock",
        icon: faDiamondTurnRight,
        color: "text-orange-700",
        url: linksUrl.rptSinglePktLotWiseStock,
      },
      {
        name: "Single Packet Inward Stock",
        key: "SinglePacketInwardStock",
        icon: faCartFlatbed,
        color: "text-orange-700",
        url: linksUrl.rptSinglePktInwardStock,
      },
      {
        name: "Single Packet Stock View",
        key: "SinglePacketStockView",
        icon: faGem,
        color: "text-orange-700",
        url: linksUrl.stockEntry.stockReport,
      },
      {
        name: "Lot OverAll View",
        key: "LotwiseCostingReport",
        icon: faRankingStar,
        color: "text-orange-700",
        url: linksUrl.rptLotwiseCosting,
      },

      {
        name: "Outstanding Report",
        key: "OutstandingReport",
        icon: faRankingStar,
        color: "text-orange-700",
        url: linksUrl.outstanding.report,
      },
      {
        name: "Packet Information",
        key: "PacketInformationReport",
        icon: faBoxesPacking,
        color: "text-orange-700",
        url: linksUrl.rptPacketInfo,
      },
      {
        name: "GST Report",
        key: "GstReport",
        icon: faRssSquare,
        color: "text-orange-700",
        url: linksUrl.gstReport.mainGst,
      },


    ],
  },
  {
    name: "Packet Transfer",
    key: "PacketTransfer",
    icon: faBoxesPacking,
    color: "text-violet-900",
    sub: [
      {
        name: "Polish",
        key: "PolishPacketTrasnfer",
        icon: faArrowDownWideShort,
        sub: [
          {
            name: "Single",
            key: "PolishPacketTrasnferSingle",
            icon: faAnglesRight,
            url: linksUrl.packetTrasnferEntry.polishStock + "/" + URIEncrypt.Polish + "/" + URIEncrypt.SinglePacket + linksUrl.packetTrasnferEntry.entrysingleMaster,
          },
          {
            name: "Mix",
            key: "PolishPacketTrasnferMix",
            icon: faAnglesRight,
            url: linksUrl.packetTrasnferEntry.polishStock + "/" + URIEncrypt.Polish + "/" + URIEncrypt.Mix + linksUrl.packetTrasnferEntry.entrymixMaster,
          },
        ],
      },
      {
        name: "Rough",
        key: "RoughPacketTransfer",
        icon: faArrowDownWideShort,
        sub: [
          {
            name: "Single",
            key: "RoughPacketTransferSingle",
            icon: faAnglesRight,
            url: linksUrl.packetTrasnferEntry.roughStock + "/" + URIEncrypt.Rough + "/" + URIEncrypt.SinglePacket + linksUrl.packetTrasnferEntry.entrysingleMaster,
          },
          {
            name: "Mix",
            key: "RoughPacketTransferMix",
            icon: faAnglesRight,
            url: linksUrl.packetTrasnferEntry.roughStock + "/" + URIEncrypt.Rough + "/" + URIEncrypt.Mix + linksUrl.packetTrasnferEntry.entrymixMaster,
          },
        ],
      },
    ]
  },
  {
    name: "Utility",
    key: "Utility",
    icon: faGears,
    color: "text-slate-900",
    sub: [
      {
        name: "User",
        key: "UserSetting",
        icon: faUserCheck,
        sub: [
          {
            name: "Company Mapping",
            key: "UserCompanyMaping",
            icon: faAnglesRight,
            url: linksUrl.userCompMaping.get,
          },

        ],
      },
      {
        name: "Stock Upload API Key",
        key: "StockUploadApiKeySetting",
        icon: faAnglesRight,
        url: linksUrl.clientApiEntry.apiEntryMaster,
      },
      {
        name: "Authentication Key",
        key: "AuthenticationKeySetting",
        icon: faAnglesRight,
        url: linksUrl.authenticationkey,
      },
      {
        name: "Account Swapping",
        key: "AccountSwapping",
        icon: faAnglesRight,
        url: linksUrl.utility.accountSwapping,
      },
    ]
  },
  {
    name: "Software Setting",
    key: "SoftwareSettings",
    icon: faScrewdriverWrench,
    color: "text-slate-900",
    sub: [

      {
        name: "Import Bills",
        key: "ImportBills",
        icon: faAnglesRight,
        url: linksUrl.modSetting.importBills,
      },

      {
        name: "Mod Settings",
        key: "ModSettings",
        icon: faAnglesRight,
        url: linksUrl.modSetting.modSettingMaster,
      },
      {
        name: "Template Settings",
        key: "TemplateSettings",
        icon: faAnglesRight,
        url: linksUrl.TemplateSettings.excelTemplateMap,
      },
      {
        name: "Report Template",
        key: "ReportTemplate",
        icon: faAnglesRight,
        url: linksUrl.reportTemplate.templateMaster,
      },


    ]
  },
]

const ENUM_DASHBOARD_COLOR = {
  Party: "party",
  jobWork: "jobwork",
  Month: "month",
  Product: "product",
  Comb_Receivable: "Receivable",
  Comb_Payable: "Payable",
  Comb_Difference: "Difference",
  Comb_MonthYear: "Monthyear"
}
export const ENUM_USERSETING_SETVALUE = {
  TextileCostFinance: "TEXTILE COST & FINANCIAL",
}

const ENUM_INPUT_TYPE = {
  text: "text",
  number: "number",
  select: "select",
  email: "email",
  date: "date",
  url: "url",
  multiline: "multiline",
  autocomplete: "autocomplete",
  inputlist: "inputlist"
}

export const ENUM_ACTYPE = {
  Transapoter: "Transapoter",
  Broker: "Broker",
  Delivery: "Delivery Party"
}


export const ENUM_ICON_MAP = {
  circle: faCircle,
  square: faSquare,
  heart: faHeart
};
export { linksUrl, outTypeEnum, stateEnum, apiRoute, sideNavLinks, ENUM_INPUT_TYPE, ENUM_DASHBOARD_COLOR }
